import React from 'react';
import TextField from '@mui/material/TextField';
import { LABEL_TEXTFORM } from './const';

export type P_TextForm = {
	value: string;
	onChange: (value: string) => any;
};
export default function TextForm(props: P_TextForm) {
	const _onChange = React.useCallback(
		(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
			props.onChange(e.target.value),
		[],
	);

	return (
		<TextField
			id='outlined-multiline-static'
			fullWidth
			multiline
			minRows={3}
			onChange={_onChange}
			label={LABEL_TEXTFORM}
			variant='outlined'
			value={props.value}
		/>
	);
}
